import * as icons from "lucide-react";
import { ExternalLink } from "lucide-react";
import { colors } from "../../../styles/theme";

export default function GuideCard({ guide, onClick, onFollowAlong }) {
  const Icon = icons[guide.icon] || icons.FileText;

  return (
    <div
      onClick={onClick}
      style={{
        border: `1px solid ${colors.border}`,
        borderRadius: 10,
        padding: 24,
        cursor: "pointer",
        transition: "all 0.15s",
        background: "white",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = colors.primary || "#4f46e5";
        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.08)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = colors.border;
        e.currentTarget.style.boxShadow = "none";
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 12,
        }}
      >
        <div
          style={{
            width: 40,
            height: 40,
            borderRadius: 8,
            background: colors.bg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon size={20} color={colors.text} />
        </div>
        <div style={{ flex: 1 }}>
          <h3
            style={{
              fontSize: 16,
              fontWeight: 600,
              margin: 0,
              color: colors.text,
            }}
          >
            {guide.title}
          </h3>
          <span style={{ fontSize: 12, color: "#999" }}>v{guide.version}</span>
        </div>
      </div>
      <p style={{ fontSize: 14, color: "#666", lineHeight: 1.5, margin: 0 }}>
        {guide.description}
      </p>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 12,
        }}
      >
        <span style={{ fontSize: 12, color: "#999" }}>
          {guide.sections.length} sections
        </span>
        {onFollowAlong && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onFollowAlong();
            }}
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 4,
              padding: "4px 10px",
              borderRadius: 5,
              border: `1px solid ${colors.border}`,
              background: "transparent",
              color: colors.textSecondary,
              fontSize: 11,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = colors.accent;
              e.currentTarget.style.color = colors.accent;
              e.currentTarget.style.background = colors.accentDim;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = colors.border;
              e.currentTarget.style.color = colors.textSecondary;
              e.currentTarget.style.background = "transparent";
            }}
            title="Open in floating panel to follow along while you work"
          >
            <ExternalLink size={12} />
            Follow Along
          </button>
        )}
      </div>
    </div>
  );
}
